import React, { useEffect, useState } from 'react'
import { subscriptionHistoryListApi } from '../../../../../services/profile';
import { toastMessage } from '../../../../../utils/toastMessage';
import { dateFormatWithTime } from '../../../../../utils/dateTimeFormat';
import { Button } from '../../../../../Components/header/form';
import CustomModal from '../../../../../Components/modals/CustomModal';
import CancelSubscription from './CancelSubscription';
import { GroupCardSkeleton } from '../../../../../shimmer/groups/GroupsListingShimmer';
import TransitionCard from '../../../../../shimmer/profile/TransitionCard';

const SubscriptionHIstory = () => {
    const [subscriptionHistoryList, setSubscriptionHistoryList] = useState([])
    const [cancelModal, setCancelModal] = useState(false)
    const [selectedData, setSelectedData] = useState({})
    const [loader, setLoader] = useState(false)

    //-----------handle-Cancel-Subscription----------
    const handleCancelSubscription = (data) => {
        setSelectedData(data)
        setCancelModal(true)
    }
    //--------subscription-history-list-------------
    const fetchSubscriptionHistoryList = async () => {
        try {
            setLoader(true)
            const { data } = await subscriptionHistoryListApi({ pagination: true });
            const { success, message, data: response } = data;
            if (success) {
                setSubscriptionHistoryList(response || [])
            } else {
                toastMessage(message, "error", "fetchSubscriptionHistory");
            }
        } catch (e) {
            console.log("Error:-", e.message);
        } finally {
            setLoader(false)
        }
    };
    useEffect(() => {
        fetchSubscriptionHistoryList()
    }, [])
    return (
        <>
            <div className="transaction_history">
                <div className="transaction_title">
                    <h2>Subscription history</h2>
                </div>
                {loader ? <TransitionCard count={5} /> : (
                    <div className="program-list">
                        {subscriptionHistoryList && subscriptionHistoryList.length > 0 ? (
                            subscriptionHistoryList.map((data, ind) => {
                                // Calculate expiration date for PENDING_CANCELLED subscriptions
                                let expirationDate = null;
                                if (data?.status === 'PENDING_CANCELLED') {
                                    const duration = data?._subscriptionPrice?.duration || 0;
                                    const interval = data?._subscriptionPrice?.interval || '';
                                    const createdAt = new Date(data?.createdAt);
                                    // Calculate expiration date based on interval and duration
                                    if (interval === 'MONTH') {
                                        expirationDate = new Date(
                                            createdAt.setMonth(createdAt.getMonth() + duration)
                                        );
                                    } else if (interval === 'YEAR') {
                                        expirationDate = new Date(
                                            createdAt.setFullYear(createdAt.getFullYear() + duration)
                                        );
                                    }
                                }
                                return (
                                    <div key={ind} className='program-item'>
                                        <img
                                            src={data?._group?.coverImage || ''}
                                            alt={data?._group?.name}
                                            className="program-image"
                                        />
                                        <div className="program-details">
                                            <h3>{data?._group?.name || "N/A"}</h3>
                                            <p>{dateFormatWithTime(data?.createdAt)}</p>
                                        </div>
                                        <p className='program-price me-3'>
                                            {data?._subscriptionPrice?.duration || "N/A"} {data?._subscriptionPrice?.interval || "N/A"} -
                                            {data?._subscriptionPrice?.currency} {data?._subscriptionPrice?.price || "N/A"}
                                        </p>
                                        {data?.status === 'PENDING_CANCELLED' ? (
                                            <>
                                                <Button>Canceled</Button>
                                                <p className="cancelled_txt">
                                                    {expirationDate
                                                        ? `Your subscription will expire on ${dateFormatWithTime(expirationDate)}`
                                                        : "Unable to determine expiration date"}
                                                </p>
                                            </>
                                        ) : (
                                            <Button onClick={() => handleCancelSubscription(data)}>Cancel</Button>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="program-item">
                                <div className="program-details text-center">
                                    <h3>No Subscription History Found</h3>
                                </div>
                            </div>
                        )}
                    </div>

                )}
            </div>
            <CancelSubscription
                show={cancelModal}
                close={() => setCancelModal(false)}
                listing={fetchSubscriptionHistoryList}
                selectedData={selectedData}
            />
        </>
    )
}

export default SubscriptionHIstory